import { render, staticRenderFns } from "./user_statistics_view_products.vue?vue&type=template&id=11011696&"
import script from "./user_statistics_view_products.vue?vue&type=script&lang=js&"
export * from "./user_statistics_view_products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports